<template>
    <a :id="buttonID" href="javascript:void(0)" class="btn" :class="buttonClasses" @click="$emit('click', $event)">
        <span v-show="isBusy">
            <img src="@/assets/tail-spin-white.svg" width="22" alt="">
        </span>
        {{ title }}
    </a>
</template>
<script>
export default {
  props: {
    isBusy: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    bootstrapClass: {
      type: String,
      default: 'btn-primary'
    }
  },
  mounted () {
    this.id = this._uid;
  },
  computed: {
    buttonID () {
      return 'btn' + this._uid;
    },
    svgSupport () {
      return (document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#AnimationEventsAttribute', '1.0'));
    },
    buttonClasses () {
      const self = this;
      return [
        {'disabled': self.isBusy},
        self.bootstrapClass
      ];
    }
  },
  watch: {
    message: function () {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }
};
</script>

<style lang="scss" scoped>
.btn.btn-primary {
    position: relative;
    &.disabled {
        padding-left: 36px;
        span {
            position: absolute;
            left: 6px;
            top: 4px;
        }
    }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
